import Label from '../helpers/Label'
export default {
  components: {Label},
  props: {
    hideLabel: Boolean,
    labelScale: {
      validator (value) {return !isNaN(value)},
      default: 1
    },
    labelBackgroundColor: {
      type: String,
      default: 'transparent'
    },
    text: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: 'black'
    },
    textHeight: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    textWidth: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    labelRotation: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    usePreciseBackground: Boolean,
    preciseBackgroundPadding: {
      validator (value) {return !isNaN(value)},
      default: 5
    },
    noEllipsis: Boolean,
    zeroRotationLabel: Boolean,
  },
  data () {
    return {
      preciseBackgroundHeight: null,
      preciseBackgroundWidth: null,
    }
  },
  computed: {
    // Offsets make rotation calculations center-focused, rather than upper-left corner
    labelConfig () {
      const {height, width, rotation, transformerTargetName, noEllipsis} = this.$props
      let labelRotation = 0
      if (this.zeroRotationLabel) labelRotation = -rotation
      else if (this.labelRotation) labelRotation = parseFloat(this.labelRotation)
      return {
        height: parseFloat(height) / this.labelScale, 
        width: parseFloat(width) / this.labelScale,
        name: `${this.name}-label`,
        baseName: this.name,
        text: this.text,
        scaleX: this.labelScale,
        scaleY: this.labelScale,
        fill: this.textColor,
        wrap: 'none',
        ellipsis: !noEllipsis,
        align: 'center',
        verticalAlign: 'middle',
        rotation: labelRotation,
        transformerTargetName,
        offset: {
          x: width / 2 / this.labelScale, 
          y: height / 2 / this.labelScale
        }
      }
    },
    labelBackgroundProps () {
      const {usePreciseBackground, textHeight, textWidth} = this.$props
      if (usePreciseBackground) {
        return {
          textHeight: this.preciseBackgroundHeight,
          textWidth: this.preciseBackgroundWidth
        }
      } 
      return {textHeight, textWidth}
    }
  },
  mounted () {this.getPreciseBackgroundDimensions()},
  watch: {
    text () {this.getPreciseBackgroundDimensions()}
  },
  methods: {
    getPreciseBackgroundDimensions () {
      const {height, width} = this.$props
      setTimeout(() => { // Let the rest of the canvas update first
        const textNode = this.$refs.label?.$refs.text?.getNode()
        this.preciseBackgroundHeight = Math.min((((textNode?.textHeight ?? 0) * textNode?.attrs.text.split('\n').length) || 0) + (this.preciseBackgroundPadding || 0), height || 0) // eslint-disable-line
        this.preciseBackgroundWidth = Math.min((textNode?.textWidth ?? 0) + (this.preciseBackgroundPadding || 0), width || 0) //eslint-disable-line
      })
    }
  }
}